import styled, { css } from 'styled-components';

import { font, themeValue, withSiteTheme } from '../../../../config/css';

const LabelTheme = {
  default: css`
    display: inline-block;
    font: ${font('0.9rem', 'md', 'pnb')};
    letter-spacing: ${themeValue('letterSpacing', 'md')};
    padding: 0.3rem 1rem 0.4rem;
    text-transform: uppercase;

    .document-browse-card__image-wrapper & {
      left: 0;
      position: absolute;
      top: 1rem;
    }
  `,
  atk: css`
    background-color: ${themeValue('colors', 'mint')};
    color: ${themeValue('colors', 'white')};
  `,
  cco: css`
    background-color: ${themeValue('colors', 'black')};
    color: ${themeValue('colors', 'white')};
  `,
  cio: css`
    background-color: ${themeValue('colors', 'squirrel')};
    color: ${themeValue('colors', 'white')};
  `,
};

const DocumentBrowseCardLabel = styled.span.attrs((props) => ({
  className: [props.className, 'document-browse-card__label'].join(' '),
}))`
  ${withSiteTheme(LabelTheme)}
`;

export default DocumentBrowseCardLabel;
